module.exports = __webpack_public_path__ + "static/office-42ec25d1a5da99ab7c5b1e8d0301dc21.jpg";